module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/JFK.dfdb377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/JFK.jpg
// module id = dMQw
// module chunks = 0